import _ from 'lodash'
import { PlayerInterface } from '@/common/utils/player.interface'

export default {
  props: {
    contentInfo: {
      type: Object
    }
  },
  computed: {
    actorList () {
      return this.getList('actors')
    },
    directorList () {
      return this.getList('directors')
    },
    seasonActorList () {
      return this.getList('season_actors')
    },
    seasonDirectorList () {
      return this.getList('season_directors')
    },
    seasonWriterList () {
      return this.getList('season_writers')
    },
    tagList () {
      return this.getList('tags')
    },
    hasActorList () {
      return this.hasList('actors')
    },
    hasDirectorList () {
      return this.hasList('directors')
    },
    hasTagList () {
      return this.hasList('tags')
    },
    hasSeasonActorList () {
      return this.hasList('season_actors')
    },
    hasSeasonDirectorList () {
      return this.hasList('season_directors')
    },
    hasSeasonWriterList () {
      return this.hasList('season_writers')
    }
  },
  methods: {
    getList (keyName) {
      return _.get(this.contentInfo, [keyName, 'list'], [])
    },
    hasList (keyName) {
      return this.getList(keyName).length > 0 && +_.get(this.contentInfo, [keyName, 'count'], 0) > 0
    }
  }
}
